<template>
  <div :class="['subscribe__step', { open: isOpen }]">
    <div class="subscribe__step-head">
      <slot name="head" />
      <button
        type="button"
        class="subscribe__step-toggler"
        @click="onToggleClick"
        :aria-expanded="isOpen"
        :aria-disabled="disabled ? 'true' : undefined"
        :aria-describedby="disabled && disabledTooltipId ? disabledTooltipId : undefined"
        :aria-label="isOpen ? t('stepBtnAriaLabelClose') : t('stepBtnAriaLabelOpen')"
      >
        <slot name="toggler-content" />
      </button>
    </div>

    <transition
      @before-enter="beforeEnter"
      @enter="enter"
      @after-enter="afterEnter"
      @before-leave="beforeLeave"
      @leave="leave"
      @after-leave="afterLeave"
    >
      <div v-if="isOpen" class="subscribe__step-content">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const i18n = {
  uk: { 
    stepBtnAriaLabelOpen: 'Відкрити крок',
    stepBtnAriaLabelClose: 'Закрити крок'
  },
  ru: { 
    stepBtnAriaLabelOpen: 'Открыть шаг',
    stepBtnAriaLabelClose: 'Закрыть шаг'
  },
}
const locale = computed(() => window.Shopify?.locale || 'uk')
const t = (key) => i18n[locale.value]?.[key] || key
const props = defineProps({
  isOpen: Boolean,
  disabled: Boolean,
  disabledTooltipId: { type: String, default: '' }
})

const emit = defineEmits(['toggle'])

const onToggleClick = () => {
  if (props.disabled) return
  emit('toggle')
}

/* ========= animation ========= */

const beforeEnter = (el) => {
  el.style.height = '0'
  el.style.opacity = '0'
  el.style.overflow = 'hidden'
}
const enter = (el) => {
  el.style.transition = 'height 280ms ease, opacity 280ms ease'
  void el.offsetHeight
  el.style.height = el.scrollHeight + 'px'
  el.style.opacity = '1'
}
const afterEnter = (el) => {
  el.style.height = 'auto'
  el.style.overflow = ''
}
const beforeLeave = (el) => {
  el.style.height = el.scrollHeight + 'px'
  el.style.opacity = '1'
  el.style.overflow = 'hidden'
}
const leave = (el) => {
  el.style.transition = 'height 280ms ease, opacity 280ms ease'
  void el.offsetHeight
  el.style.height = '0'
  el.style.opacity = '0'
}
const afterLeave = (el) => {
  el.style.height = ''
  el.style.opacity = ''
}
</script>
